import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import Loader from '../Loader';
import ErrorMessage from './ErrorMessage';
import CardTypeLogos from './CardTypeLogos';
import SecurityMetricsIcon from './SecurityMetricsIcon';
import { MONTHS_AS_OPTIONS } from './constants/months';
import { YEARS_AS_OPTIONS } from './constants/years';
import { COUNTRIES_AS_OPTIONS } from './constants/countries';
import { STATES_USA_AS_OPTIONS, STATES_CANADA_AS_OPTIONS } from './constants/states';
import { detectCardType } from './constants/cardTypes';
import { FIELDS, REQUIRED_ICON_RENDER } from './constants/fields';
import { ERRORS } from './constants/errors';
import { T } from '../../stores/textStore';
import store from '../../store';
import shopStore from '../../stores/shopStore';

class BillingForm extends Component {

	constructor(props) {
		super(props);
		this.firstnameInputRef = React.createRef();
		const { billingInfo } = shopStore;
		if (!billingInfo.get('country')) {
			billingInfo.set('country', 'US');
		}
		this.state = { wantsBookShipped: true }		
	}

	componentDidMount() {		
		//this.firstnameInputRef.current.focus();		
		if (typeof window.grecaptcha === 'object' && 
				typeof window.grecaptcha.render === 'function') {			
			this.recaptchaWidgetId = window.grecaptcha.render('recaptcha-target');			
		}
		if (this.isShippable()) {
			const { billingInfo } = shopStore;
			billingInfo.set('shippingisbilling', true);
			if (!billingInfo.get('shipcountry')) {
				billingInfo.set('shipcountry', 'US');
			}							
		}
	}

	validate(fieldName) {
		const { billingInfo, billingInfoErrors } = shopStore;
		billingInfoErrors.delete(fieldName);			
		if (!billingInfo.get(fieldName) && this.isRequired(fieldName)) {
			billingInfoErrors.set(fieldName, ERRORS.REQUIRED);
		} else if (billingInfo.get(fieldName) && FIELDS[fieldName].regex &&
				!FIELDS[fieldName].regex.test(billingInfo.get(fieldName))) {
			billingInfoErrors.set(fieldName, `Please enter a valid ${FIELDS[fieldName].label}`);
		} else if (fieldName === 'ccnumber' && !billingInfo.get('paymentmethod')) {
			console.log('HHHHHHH', billingInfo.get('paymentmethod'));
			const hc = shopStore.cart.get('hypoCashsale');
			if (!hc || (hc.total > 0)) {
				billingInfoErrors.set(fieldName, ERRORS.INVALID_CCNUMBER);
			} else {
				billingInfo.set('ccnumber', '');
				billingInfo.set('paymentmethod', '');
			}
		}
	}

	isTotalZero() {		
		const hc = shopStore.cart.get('hypoCashsale');		
		return (hc && hc.total && !(parseFloat(hc.total) > 0));
	}

	isShippable() {		
		return false;
		if (!window.tkcWidgetContext.ticketId) {
			return false;
		}
		const tickets = ['259426', '590645'];		
		if (tickets.indexOf(window.tkcWidgetContext.ticketId) === -1) {
			return false;
		}
		const hc = shopStore.cart.get('hypoCashsale');
		if (parseFloat(hc.total) < window.tkcWidgetContext.amounts[0]) {
			return false;
		}
		return true;
	}

	validateEntireForm() {
		for (let key in FIELDS) {
			this.validate(key);
		}
	}

	isFormValid() {		
		if (typeof window.grecaptcha === 'object' &&
				typeof window.grecaptcha.render === 'function') {
			const recaptchaResponse = window.grecaptcha.getResponse(this.recaptchaWidgetId);
			if (!recaptchaResponse) {
				return false;
			}
		}
		return !shopStore.billingInfoErrors.size;
	}	

	isRequired(fieldName) {
		const { billingInfo } = shopStore;
		let required = FIELDS[fieldName].required;	
		if ((fieldName === 'state' || fieldName === 'zip') && 
				(billingInfo.get('country') === 'US' || billingInfo.get('country') === 'CA')) {
			return true;
		} else if (fieldName === 'email' && store.guestSessionMode) {
			return true;
		} else if (fieldName === 'ccnumber' || fieldName === 'ccname' || 
				fieldName === 'ccexpiremonth' || fieldName === 'ccexpireyear' ||
				fieldName === 'paymentmethod') {
			const hc = shopStore.cart.get('hypoCashsale');
			if (hc && hc.total && !(parseFloat(hc.total) > 0)) {
				return false;
			}
		} else if (fieldName.substring(0, 4) === 'ship' && 
				(!this.isShippable() || billingInfo.get('shippingisbilling'))) {
			return false;
		}
		return required;	
	}

	handleChange = (event) => {
		event.preventDefault();
		const { billingInfo, billingInfoErrors } = shopStore;
		billingInfo.set(event.target.name, event.target.value);	
		if (event.target.name === 'ccnumber') {
			this.handleCCNumberChange();
		}	
		else if (event.target.name === 'country') {
			billingInfo.set('state', '');
			billingInfoErrors.delete('state');
			billingInfoErrors.detle('zip')
		}	
		if (billingInfoErrors.get(event.target.name)) {
			this.validate(event.target.name);
		}
	}

	handleWantsBookShippedChange = (event) => {
		this.setState({ wantsBookShipped: event.target.value !== '0' });
	}

	handleShippingIsBillingChange = (event)	=> {
		const { billingInfo } = shopStore;
		billingInfo.set(event.target.name, event.target.checked);	
	}

	handleBlur = (event) => {
		event.preventDefault();
		this.validate(event.target.name);
	}	

	handleCCNumberChange() {
		const { billingInfo } = shopStore;
		const cardType = detectCardType(billingInfo.get('ccnumber'));
		if (!cardType) {
			billingInfo.set('paymentmethod', '');
			return;
		}
		billingInfo.set('paymentmethod', cardType.paymentMethod);
	}

	handleSubmit = (event) => {
		if (typeof window.grecaptcha === 'object') {
			shopStore.recaptchaResponse = 
				window.grecaptcha.getResponse(this.recaptchaWidgetId);
		}
		event.preventDefault();
		this.validateEntireForm();		
		if (!this.isFormValid()) {
			this.firstnameInputRef.current.focus();			
		} else {
			const { billingInfo } = shopStore;
			if (!this.state.wantsBookShipped || billingInfo.get('shippingisbilling')) {
				billingInfo.set('shipcountry', '');
			}
			shopStore.purchaseCart();
		}
	}	

	renderInput(name) {
		const { billingInfo, billingInfoErrors, processingOrder } = shopStore;			
		return (
			<span>
				<label>
					{this.isRequired(name) && REQUIRED_ICON_RENDER}							
					{T(FIELDS[name].label)}
				</label>
				<input 				
					type="text" 
					className={'form-control rounded-0' + (billingInfoErrors.get(name) ? ' is-invalid' : '')}
					name={name} 
					placeholder="" 
					value={billingInfo.get(name)} 
					onChange={this.handleChange}
					onBlur={this.handleBlur}
					ref={name === 'firstname' ? this.firstnameInputRef : null}
					disabled={processingOrder.get()}
				/>
				<ErrorMessage text={billingInfoErrors.get(name)} />
			</span>
		);
	}

	renderSelect(name) {
		const { billingInfo, billingInfoErrors, processingOrder } = shopStore;
		let optionsRender = [];
		if (name === 'ccexpiremonth') {
			optionsRender.push(<option key='EMPTY' value=""></option>);
			optionsRender = optionsRender.concat(MONTHS_AS_OPTIONS);
		} else if (name === 'ccexpireyear') {
			optionsRender.push(<option key='EMPTY' value=""></option>);
			optionsRender = optionsRender.concat(YEARS_AS_OPTIONS);			
		} else if (name === 'country' || name === 'shipcountry') {			
			optionsRender = optionsRender.concat(COUNTRIES_AS_OPTIONS);			
		} else if (name === 'state') {
			optionsRender.push(<option key='EMPTY' value=""></option>);
			if (billingInfo.get('country') === 'US') {
				optionsRender = optionsRender.concat(STATES_USA_AS_OPTIONS);
			} else if (billingInfo.get('country') === 'CA') {
				optionsRender = optionsRender.concat(STATES_CANADA_AS_OPTIONS);
			}	
		} else if (name === 'shipstate') {
			optionsRender.push(<option key='EMPTY' value=""></option>);
			if (billingInfo.get('shipcountry') === 'US') {
				optionsRender = optionsRender.concat(STATES_USA_AS_OPTIONS);
			} else if (billingInfo.get('shipcountry') === 'CA') {
				optionsRender = optionsRender.concat(STATES_CANADA_AS_OPTIONS);
			}
		} 
		return (
			<span>
				<label>
					{this.isRequired(name) && REQUIRED_ICON_RENDER}							
					{T(FIELDS[name].label)}
				</label>
				<select                   								 
					className="form-control rounded-0" 
					name={name}								
					value={billingInfo.get(name)}
					onChange={this.handleChange}
					onBlur={this.handleBlur}
					disabled={processingOrder.get()}
				>
					{optionsRender}
				</select>
				<ErrorMessage text={billingInfoErrors.get(name)} />		
			</span>
		);
	}	

	renderShippingSection() {		
		const { billingInfo } = shopStore;	
		const hc = shopStore.cart.get('hypoCashsale');
		let copy1 = T('Your contribution is eligible for a free copy of Rethink Love by Monica Berg. Please provide your shipping address below to receive your copy.');				
		let copy2 = T("I don't want to receive my free copy");
		let copy3 = T("Yes, please ship my free copy");		
		if (parseFloat(hc.total) >= 75.0) {
			copy1 = T('Your contribution is eligible for a free copy of Rethink Love by Monica Berg and the Rethink Love Workbook. Please provide your shipping address below to receive your copy.');				
			copy2 = T("I don't want to receive my free copy and workbook");
			copy3 = T("Yes, please ship my free copy and workbook");				
		}
		return (
			<span>
				<hr className="mb-4" />	
				<div className="row">						
					<div className="col-sm-12">
						<h5>
							<span className="text-success">{T('Congratulations!')}</span>&nbsp;
							{copy1}	
						</h5>											
						<div className="form-check my-2">
							<input 
								className="form-check-input" 
								type="radio" 
								value={0} 
								checked={this.state.wantsBookShipped === false}
								onChange={this.handleWantsBookShippedChange}
							/>
							<label className="form-check-label">
								{copy2}
							</label>
						</div>
						<div className="form-check my-2">
							<input 
								className="form-check-input" 
								type="radio" 
								value={1} 
								checked={this.state.wantsBookShipped === true}
								onChange={this.handleWantsBookShippedChange}
							/>
							<label className="form-check-label">
								{copy3}
							</label>						
						</div>																																					
					</div>	
				</div>				
				{this.state.wantsBookShipped &&
				<span>
					<div className="row pl-4">					
						<div className="col-sm-12">
							<h4 className="mb-3">{T('Shipping Address')}</h4>
							<div className="form-check mb-3">
								<input 
										type="checkbox" 
										className="form-check-input" 
										name="shippingisbilling" 
										checked={shopStore.billingInfo.get('shippingisbilling')}							
										onChange={this.handleShippingIsBillingChange}							
								/>					
								<label className="form-check-label font-weight-bold">
									{T('Same as billing address?')}
								</label>
							</div>
						</div>	
					</div>							
					{!shopStore.billingInfo.get('shippingisbilling') &&
					<div className="row pl-4">							
						<div className="col-sm-12 _form-group">
							{this.renderInput('shipaddr1')}
						</div>
						<div className="col-sm-12 _form-group">
							{this.renderInput('shipaddr2')}
						</div>
						<div className="col-sm-8 _form-group">
							{this.renderInput('shipcity')}
						</div>
						{billingInfo.get('shipcountry') !== 'US' && billingInfo.get('country') !== 'CA' &&
							<div className="col-sm-4 _form-group">
								{this.renderInput('shipstate')}
							</div>
						}
						{(billingInfo.get('shipcountry') === 'US' || billingInfo.get('country') === 'CA') &&
							<div className="col-sm-4 _form-group">							
								{this.renderSelect('shipstate')}
							</div>
						}
						<div className="col-sm-6 _form-group">
							{this.renderInput('shipzip')}
						</div>						
						<div className="col-sm-6 _form-group">
							{this.renderSelect('shipcountry')}
						</div>			
					</div>	
					}
				</span>				
				}																
			</span>					
		);
	}

	render() {			
		const { billingInfo } = shopStore;
		const processing = shopStore.processingOrder.get();			
		let submitLabel = T('Place Order');
		if (this.props.submitLabel) {
			submitLabel = this.props.submitLabel;
		}
		return (
			<span>				
				<form className="needs-validation" noValidate onSubmit={this.handleSubmit}>
					<div className="row">
						<div className="col-sm-12">
							<h3 className="font-weight-bold">{T('Billing Information')}</h3>
						</div>																	
						<div className="col-sm-6 _form-group">
							{this.renderInput('firstname')}
						</div>
						<div className="col-sm-6 _form-group">
							{this.renderInput('lastname')}
						</div>
						{store.guestSessionMode && 
							<div className="col-sm-12 _form-group">
								{this.renderInput('email')}
							</div>
						}							
						<div className="col-sm-12 _form-group">
							{this.renderInput('addr1')}
						</div>
						<div className="col-sm-12 _form-group">
							{this.renderInput('addr2')}
						</div>
						<div className="col-sm-7 _form-group">
							{this.renderInput('city')}
						</div>
						{billingInfo.get('country') !== 'US' && billingInfo.get('country') !== 'CA' &&
							<div className="col-sm-5 _form-group">
								{this.renderInput('state')}
							</div>
						}
						{(billingInfo.get('country') === 'US' || billingInfo.get('country') === 'CA') &&
							<div className="col-sm-5 _form-group">							
								{this.renderSelect('state')}
							</div>
						}
						<div className="col-sm-6 _form-group">
							{this.renderInput('zip')}
						</div>						
						<div className="col-sm-6 _form-group">
							{this.renderSelect('country')}
						</div>								
						<div className="col-sm-6 _form-group">
							{this.renderInput('mobilephone')}
						</div>	
						<div className="col-sm-6 _form-group">
							{this.renderInput('homephone')}
						</div>																																																																	
					</div>						
					{this.isShippable() && this.renderShippingSection()}
					{!this.isTotalZero() && 
						<span>							
							<div className="row">						
								<div className="col-sm-12">
									<h3 className="font-weight-bold">Payment Details</h3>
								</div>	
								<div className="col-sm-6 _form-group">
									{this.renderInput('ccnumber', true)}
								</div>							
								<div className="col-sm-6 _form-group my-auto">						
									<CardTypeLogos />
								</div>																	
								<div className="col-sm-6 _form-group">
									{this.renderInput('ccname', true)}
								</div>	
								<div className="col-sm-6 _form-group">
									{this.renderInput('ccsecuritycode', true)}
								</div>																											
								<div className="col-sm-6 _form-group">
									{this.renderSelect('ccexpiremonth')}
								</div>	
								<div className="col-sm-6 _form-group">	
									{this.renderSelect('ccexpireyear')}
								</div>							
							</div>
						</span>
					}								
					<div className="row">						
						<div 
							className="col-sm-12 mb-3"
							id="recaptcha-target"
							data-sitekey="6LeDf5MUAAAAAM7KuY7WBE5vJm1QWQn4BWkAdTKL"
						>
						</div>					
						<div className="col-sm-12">																
							{!processing &&
								<button 
									type="submit" 
									className="tkc-btn btn-block tkc-btn-red rounded-0" 																						
								>
									{submitLabel}
								</button>	  
							}  
							{processing && 
								<button 
									className="tkc-btn btn-block tkc-btn-outline-red rounded-0" 
									disabled
								>
									Processing... <Loader />             
								</button>	             
							}  
						</div> 	
						<div className="col-sm-12 text-center _form-group mt-3">								
							<SecurityMetricsIcon />
						</div>																			
					</div>	
					<hr className="mb-4 mt-4" />									
					<div className="row">
						<div className="col-sm-12 _form-group small text-muted">										 															
							<p>
								Kabbalah Centre International, Inc.<br />
								1062 S. Robertson Blvd., Los Angeles, CA 90035, USA
							</p>																								
							<p>Merchant Outlet is USA.</p>
						</div>						
					</div>															
				</form>
			</span>
		);
	}

}

export default observer(BillingForm);



// WEBPACK FOOTER //
// ./src/components/billing-form/BillingForm.js